(() => {
  const normalize = (value) => value.trim().toLocaleLowerCase('de');
  const triggers = new Set();
  let activeDisclosure = null;
  let initiator = null;
  let mobilePanel = null;
  let touchStart = null;
  let lastTouchLink = null;
  let lastTouchTime = 0;

  const desktopVisible = (menu) => Boolean(menu?.closest('.header-navs')?.getClientRects().length && getComputedStyle(menu.closest('.header-navs')).display !== 'none');

  const desktopMenu = () => Array.from(document.querySelectorAll('.js-primary-nav header-details-disclosure'))
    .find((element) => normalize(element.querySelector('details')?.dataset.linkTitle || '') === 'duftfinder');

  const mobileMenu = () => Array.from(document.querySelectorAll('.js-menu-draw drawer-menu details'))
    .find((element) => normalize(element.querySelector(':scope > summary')?.textContent || '') === 'duftfinder');

  const isFinderTrigger = (link) => {
    if (link.closest('.js-header, .js-menu-draw')) return false;
    if (link.hasAttribute('data-ho3-duftfinder-open')) return true;
    if (/referenz|vergleich|duftnot|duftrichtung/i.test(link.textContent + ' ' + (link.getAttribute('aria-label') || ''))) return false;
    try {
      const url = new URL(link.href, location.href);
      return url.origin === location.origin && /\/pages\/duftfinder\/?$/.test(url.pathname) && !url.search && !url.hash;
    } catch {
      return false;
    }
  };

  const setExpanded = (expanded) => {
    triggers.forEach((link) => {
      if (link.isConnected) link.setAttribute('aria-expanded', String(expanded));
    });
  };

  const releaseHeader = () => {
    document.body.removeAttribute('data-ho3-duftfinder-open');
    document.body.removeAttribute('data-ho3-duftfinder-lift');
    const section = document.querySelector('.js-section__header');
    section?.style.removeProperty('--ho3-header-height');
    section?.style.removeProperty('--ho3-menu-height');
    activeDisclosure = null;
    setExpanded(false);
  };

  const restoreFocus = () => {
    if (initiator?.isConnected) initiator.focus({ preventScroll: true });
    initiator = null;
  };

  const closeDesktop = (focus = false) => {
    activeDisclosure?.close();
    releaseHeader();
    if (focus) restoreFocus();
  };

  const openDesktop = (disclosure, link) => {
    closeDesktop();
    initiator = link;
    const section = document.querySelector('.js-section__header');
    const header = section?.querySelector('.js-header');
    if (!header || typeof disclosure.open !== 'function') return false;
    const bounds = header.getBoundingClientRect();
    section.style.setProperty('--ho3-header-height', `${Math.round(section.offsetHeight)}px`);
    document.body.setAttribute('data-ho3-duftfinder-open', '');
    if (bounds.top < 0 || bounds.bottom <= 0) document.body.setAttribute('data-ho3-duftfinder-lift', '');
    const headerBottom = document.body.hasAttribute('data-ho3-duftfinder-lift') ? header.offsetHeight : bounds.bottom;
    section.style.setProperty('--ho3-menu-height', `${Math.max(120, window.innerHeight - headerBottom - 16)}px`);
    document.body.classList.remove('header-up');
    document.body.classList.add('header-down');
    document.querySelectorAll('.js-primary-nav header-details-disclosure').forEach((other) => {
      if (other !== disclosure && other.querySelector('details[open]')) other.close();
    });
    activeDisclosure = disclosure;
    disclosure.open();
    const details = disclosure.querySelector('details');
    if (!details.dataset.ho3FinderBound) {
      details.dataset.ho3FinderBound = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open && activeDisclosure === disclosure) releaseHeader();
      });
    }
    setExpanded(true);
    disclosure.querySelector('summary')?.focus({ preventScroll: true });
    return true;
  };

  const openMobile = (panel, link) => {
    const drawer = panel.closest('drawer-menu');
    if (typeof window.theme?.mfpOpen !== 'function' || typeof drawer?.openMenuPanelById !== 'function') return false;
    closeDesktop();
    initiator = link;
    mobilePanel = panel;
    window.theme.mfpOpen('menu-draw');
    drawer.openMenuPanelById(panel.id, false, true);
    setExpanded(true);
    return true;
  };

  const decorate = () => {
    const desktop = desktopMenu();
    const mobile = mobileMenu();
    const panel = desktop?.querySelector('summary')?.nextElementSibling;
    const isDesktop = desktopVisible(desktop);
    if (!panel && !mobile) return;
    document.querySelectorAll('a[href]').forEach((link) => {
      if (!isFinderTrigger(link)) return;
      triggers.add(link);
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', String(Boolean(activeDisclosure || mobilePanel?.open)));
      link.setAttribute('aria-controls', isDesktop ? panel.id : (mobile?.querySelector(':scope > summary')?.nextElementSibling.id || panel.id));
    });
    if (mobile && !mobile.dataset.ho3FinderBound) {
      mobile.dataset.ho3FinderBound = 'true';
      mobile.addEventListener('toggle', () => {
        if (!mobile.open && mobilePanel === mobile) {
          mobilePanel = null;
          setExpanded(false);
        }
      });
    }
  };

  const activateFinder = (event) => {
    if ((event.type === 'click' && event.button !== 0) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !isFinderTrigger(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    // A touch activation may also produce a synthetic click on some browsers.
    if (event.type === 'click' && lastTouchLink === link && Date.now() - lastTouchTime < 800) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const desktop = desktopMenu();
    const isDesktop = desktopVisible(desktop);
    const mobile = isDesktop ? null : mobileMenu();
    if ((isDesktop && typeof desktop.open === 'function') ||
        (mobile && typeof window.theme?.mfpOpen === 'function' && typeof mobile.closest('drawer-menu')?.openMenuPanelById === 'function')) {
      triggers.add(link);
      // Cancel the link before opening: theme touch handlers must not navigate.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (event.type === 'touchend') {
        lastTouchLink = link;
        lastTouchTime = Date.now();
      }
      if (isDesktop) openDesktop(desktop, link);
      else openMobile(mobile, link);
    }
  };

  document.addEventListener('click', activateFinder, true);
  document.addEventListener('touchstart', (event) => {
    const touch = event.touches.length === 1 ? event.touches[0] : null;
    touchStart = touch ? { id: touch.identifier, x: touch.clientX, y: touch.clientY } : null;
  }, { capture: true, passive: true });
  document.addEventListener('touchmove', (event) => {
    const touch = Array.from(event.touches).find((item) => item.identifier === touchStart?.id);
    if (!touch || Math.hypot(touch.clientX - touchStart.x, touch.clientY - touchStart.y) > 12) touchStart = null;
  }, { capture: true, passive: true });
  document.addEventListener('touchcancel', () => { touchStart = null; }, { capture: true, passive: true });
  document.addEventListener('touchend', (event) => {
    const touch = Array.from(event.changedTouches).find((item) => item.identifier === touchStart?.id);
    if (touch && Math.hypot(touch.clientX - touchStart.x, touch.clientY - touchStart.y) <= 12) activateFinder(event);
    touchStart = null;
  }, { capture: true, passive: false });

  document.addEventListener('pointerdown', (event) => {
    if (activeDisclosure && !activeDisclosure.contains(event.target)) closeDesktop();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeDisclosure) {
      event.preventDefault();
      closeDesktop(true);
    }
  });

  document.addEventListener('focusin', (event) => {
    if (activeDisclosure && !activeDisclosure.contains(event.target) && event.target !== initiator) closeDesktop();
  });

  window.addEventListener('resize', () => {
    if (activeDisclosure && getComputedStyle(activeDisclosure.closest('.header-navs')).display === 'none') closeDesktop(true);
    decorate();
  });

  document.addEventListener('shopify:section:load', decorate);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate, { once: true });
  else decorate();
})();
